export const IsPC = () => {
    // SSR 场景兜底认为是 PC
    if (typeof navigator === 'undefined') return true;
  
    // 1) UA-CH（更可靠）—— 仅在支持的浏览器可用
    const uad = navigator.userAgentData;
    if (uad && Object.prototype.hasOwnProperty.call(uad, 'mobile')) {
      return !uad.mobile;
    }
  
    // 2) 回退 UA 字符串
    const ua = (navigator.userAgent || '').toLowerCase();
  
    const mobileTokens = [
      // 通用移动
      'android', 'iphone', 'ipad', 'ipod', 'symbianos', 'windows phone',
      // 华为/鸿蒙
      'harmonyos', 'openharmony', 'huaweibrowser', 'huawei', 'hm os', 'hmscore',
      // 小米系
      'xiaomi', 'miui', 'mi browser', 'miuibrowser', 'redmi', 'blackshark',
      // 其他国产/常见
      'oppo', 'coloros', 'vivo', 'originos', 'realme', 'oneplus', 'meizu', 'flyme'
    ];
  
    if (mobileTokens.some(t => ua.includes(t))) return false;
  
    // 3) iPadOS 13+ 伪装成 macOS：用触控点兜底
    const isAppleTabletPretendingDesktop =
      /\bmac os x\b/.test(ua) &&
      typeof navigator.maxTouchPoints === 'number' &&
      navigator.maxTouchPoints > 1;
  
    if (isAppleTabletPretendingDesktop) return false;
  
    return true;
};